<template>
  <div class="task-log-records__record" :class="`is-${level}`">
    <div class="task-log-records__time">
      {{ source.time | formatTime }}
    </div>
    <div class="task-log-records__output" v-html="$options.filters.formatLog(source.output)">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    index: { // index of current item
      type: Number,
    },
    source: { // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    level() {
      const text = `${this.source.output || ''}`.trim().toLowerCase();
      if (/^(fatal|failed|error|unreachable)/.test(text)) return 'error';
      if (/^(ok:|changed:|skipping:)/.test(text)) return 'ok';
      if (/^(task \[|play \[|task:)/.test(text)) return 'task';
      return 'info';
    },
  },
};
</script>
